import React from "react";
import { withStyles } from "@material-ui/core/styles";
import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import axios from "axios";
const Accordion = withStyles({
  root: {
    border: "1px solid rgba(0, 0, 0, .125)",
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      margin: "auto",
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    backgroundColor: "rgba(0, 0, 0, .03)",
    borderBottom: "1px solid rgba(0, 0, 0, .125)",
    marginBottom: -1,
    minHeight: 56,
    "&$expanded": {
      minHeight: 56,
    },
  },
  content: {
    "&$expanded": {
      margin: "12px 0",
    },
  },
  expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiAccordionDetails);

export default function CustomizedAccordions(props) {
  const curUser = props.user;

  const entreeItems = props.menu;
  const sideItems = props.sides;
  const drinkItems = props.drinks;

  const [menuName, setMenuName] = React.useState("Example Name");
  const [itemDescription, setItemDescription] = React.useState(
    "Example description"
  );
  const [itemName, setItemName] = React.useState("Item Name");
  const [itemPrice, setItemPrice] = React.useState("Price");

  const [open, setOpen] = React.useState(false);

  const [openDrink, setOpenDrink] = React.useState(false);
  const [openSide, setOpenSide] = React.useState(false);
  const [openEntree, setOpenEntree] = React.useState(false);

  const [expanded, setExpanded] = React.useState("panel1");

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const handleClickOpenDrink = () => {
    setOpenDrink(true);
  };
  const handleClickOpenSides = () => {
    setOpenSide(true);
  };
  const handleClickOpenEntrees = () => {
    setOpenEntree(true);
  };

  const handleClose = () => {
    setOpen(false);
    setOpenDrink(false);
    setOpenSide(false);
    setOpenEntree(false);
  };

  const handleCloseSides = () => {
    setOpenSide(false);

    const addItemData = {
      item: itemName,
      price: itemPrice,
      description: itemDescription,
    };

    axios
      .post("/menu/" + curUser + "/side", addItemData)
      .then((res) => {})
      .catch((err) => console.error(err));
    // this.forceUpdate();
    //TODO// needs to be updated later so component can update without refresh
    sideItems.push(addItemData);
  };

  const handleCloseEntree = () => {
    setOpenEntree(false);

    const addItemData = {
      item: itemName,
      price: itemPrice,
      description: itemDescription,
    };

    axios
      .post("/menu/" + curUser + "/entree", addItemData)
      .then((res) => {})
      .catch((err) => console.error(err));
    // this.forceUpdate();
    //TODO// needs to be updated later so component can update without refresh
    entreeItems.push(addItemData);
  };

  const handleCloseDrinks = () => {
    setOpenDrink(false);

    const addItemData = {
      item: itemName,
      price: itemPrice,
      description: itemDescription,
    };

    axios
      .post("/menu/" + curUser + "/drink", addItemData)
      .then((res) => {})
      .catch((err) => console.error(err));
    // this.forceUpdate();
    //TODO// needs to be updated later so component can update without refresh
    drinkItems.push(addItemData);
  };

  const saveItemDescription = (e) => {
    setItemDescription(e.target.value);
  };
  const saveItemName = (e) => {
    setItemName(e.target.value);
  };

  const saveItemPrice = (e) => {
    setItemPrice(e.target.value);
  };

  const sideClick = (option) => {
    return (
      <div >
        <Dialog
          open={openSide}
          onClose={handleCloseSides}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Add item</DialogTitle>
          <DialogContent>
            <DialogContentText>
              You can create your storefront products here.
            </DialogContentText>

            <TextField
              onChange={saveItemName}
              margin="dense"
              id="name"
              label="Item Name"
              type="text"
              fullWidth
            />
            <TextField
              onChange={saveItemPrice}
              margin="dense"
              id="name"
              label="Price"
              type="text"
              fullWidth
            />
            <TextField
              onChange={saveItemDescription}
              margin="dense"
              id="name"
              label="Description"
              type="text"
              fullWidth
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={handleCloseSides} color="primary">
              Add
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  };
  const entreeClick = (option) => {
    return (
      <div style={{maxWidth:'410px'}}>
        <Dialog
          open={openEntree}
          onClose={handleCloseEntree}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Add item</DialogTitle>
          <DialogContent>
            <DialogContentText>
              You can create your storefront products here.
            </DialogContentText>

            <TextField
              onChange={saveItemName}
              margin="dense"
              id="name"
              label="Item Name"
              type="text"
              fullWidth
            />
            <TextField
              onChange={saveItemPrice}
              margin="dense"
              id="name"
              label="Price"
              type="text"
              fullWidth
            />
            <TextField
              onChange={saveItemDescription}
              margin="dense"
              id="name"
              label="Description"
              type="text"
              fullWidth
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={handleCloseEntree} color="primary">
              Add
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  };

  const drinkClick = (option) => {
    return (
      <div>
        <Dialog
          open={openDrink}
          onClose={handleCloseDrinks}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Add item</DialogTitle>
          <DialogContent>
            <DialogContentText>
              You can create your storefront products here.
            </DialogContentText>

            <TextField
              onChange={saveItemName}
              margin="dense"
              id="name"
              label="Item Name"
              type="text"
              fullWidth
            />
            <TextField
              onChange={saveItemPrice}
              margin="dense"
              id="name"
              label="Price"
              type="text"
              fullWidth
            />
            <TextField
              onChange={saveItemDescription}
              margin="dense"
              id="name"
              label="Description"
              type="text"
              fullWidth
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={handleCloseDrinks} color="primary">
              Add
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  };

  return (
    <div style={{maxWidth:'430px'}}>
      {/* <div style={{ display: "flex" }}>
        <Accordion style={{maxWidth:'415px'}} onChange={handleChange("panel1")}>
          <AccordionSummary
            aria-controls="panel1d-content"
            id="panel1d-header"
            expandIcon={<ExpandMoreIcon />}
          >
            <Typography>Entrees</Typography>
          </AccordionSummary>

          <AccordionDetails style={{ display: "inline grid" }}>
            <div style={{maxWidth:'410px'}}>
              {entreeItems.map((item) => (
                <div key={item.item}>
                  <Typography variant="h6" style={{ fontSize: "1.00rem" }}>
                    {item.item}
                  </Typography>
                  <Typography
                    variant="body1"
                    style={{marginRight:'2vw', textAlign:"right", marginTop: "-20px" }}
                  >
                    ${item.price}
                  </Typography>
                  <Typography variant="body2" style={{ padding: "10px" }}>
                    {item.description}
                  </Typography>
                </div>
              ))}
            </div>
          </AccordionDetails>

          <div>
            <Typography
              onClick={entreeClick && handleClickOpenEntrees}
              style={{
                color: "#1da1f2",
                fontWeight: "lighter",
              }}
              title="Add"
              aria-label="add"
              placement="right"
            >
              add item
            </Typography>
            {entreeClick()}
          </div>
        </Accordion>
      </div> */}
      <div style={{ display: "flex" }}>
        <Accordion style={{maxWidth:'410px'}} onChange={handleChange("panel1")}>
          <AccordionSummary
            aria-controls="panel1d-content"
            id="panel1d-header"
            expandIcon={<ExpandMoreIcon />}
          >
            <Typography>Entrees</Typography>
          </AccordionSummary>

          <AccordionDetails style={{ display: "inline grid" }}>
            <div style={{width:'410px'}}>
              {entreeItems.map((item) => (
                <div key={item.item}>
                  <Typography variant="h6" style={{ fontSize: "1.00rem" }}>
                    {item.item}
                  </Typography>
                  <Typography
                    variant="body1"
                    style={{marginRight:'2vw', textAlign:"right", marginTop: "-20px" }}
                  >
                    ${item.price}
                  </Typography>
                  <Typography variant="body2" style={{ padding: "10px" }}>
                    {item.description}
                  </Typography>
                </div>
              ))}
            </div>
          </AccordionDetails>

          <div>
            <Typography
              onClick={entreeClick && handleClickOpenEntrees}
              style={{
                color: "#1da1f2",
                fontWeight: "lighter",
              }}
              title="Add"
              aria-label="add"
              placement="right"
            >
              add item
            </Typography>
            {entreeClick()}
          </div>
        </Accordion>
      </div>
      <div style={{ display: "flex" }}>
        <Accordion style={{maxWidth:'410px'}} onChange={handleChange("panel1")}>
          <AccordionSummary
            aria-controls="panel1d-content"
            id="panel1d-header"
            expandIcon={<ExpandMoreIcon />}
          >
            <Typography>Sides</Typography>
          </AccordionSummary>

          <AccordionDetails style={{ display: "inline grid" }}>
            <div style={{width:'410px'}}>
              {sideItems.map((item) => (
                <div key={item.item}>
                  <Typography variant="h6" style={{ fontSize: "1.00rem" }}>
                    {item.item}
                  </Typography>
                  <Typography
                    variant="body1"
                    style={{marginRight:'2vw', textAlign:"right", marginTop: "-20px" }}
                  >
                    ${item.price}
                  </Typography>
                  <Typography variant="body2" style={{ padding: "10px" }}>
                    {item.description}
                  </Typography>
                </div>
              ))}
            </div>
          </AccordionDetails>

          <div>
            <Typography
              onClick={sideClick && handleClickOpenSides}
              style={{
                color: "#1da1f2",
                fontWeight: "lighter",
              }}
              title="Add"
              aria-label="add"
              placement="right"
            >
              add item
            </Typography>
            {sideClick()}
          </div>
        </Accordion>
      </div>
  
      

      <div style={{ display: "flex" }}>
        <Accordion style={{maxWidth:'410px'}} onChange={handleChange("panel1")}>
          <AccordionSummary
            aria-controls="panel1d-content"
            id="panel1d-header"
            expandIcon={<ExpandMoreIcon />}
          >
            <Typography>Drinks</Typography>
          </AccordionSummary>

          <AccordionDetails style={{ display: "inline grid" }}>
            <div style={{width:'410px'}}>
              {drinkItems.map((item) => (
                <div key={item.item}>
                  <Typography variant="h6" style={{ fontSize: "1.00rem" }}>
                    {item.item}
                  </Typography>
                  <Typography
                    variant="body1"
                    style={{marginRight:'2vw', textAlign:"right", marginTop: "-20px" }}
                  >
                    ${item.price}
                  </Typography>
                  <Typography variant="body2" style={{ padding: "10px" }}>
                    {item.description}
                  </Typography>
                </div>
              ))}
            </div>
          </AccordionDetails>

          <div>
            <Typography
              onClick={drinkClick && handleClickOpenDrink}
              style={{
                color: "#1da1f2",
                fontWeight: "lighter",
              }}
              title="Add"
              aria-label="add"
              placement="right"
            >
              add item
            </Typography>
            {drinkClick()}
          </div>
        </Accordion>
      </div>
    </div>
  );
}
